/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-dummy-page',
  template: `
    <h1>Dummy Page for Demonstration Purposes</h1>
    <p>This is a dummy page for demonstration purposes only</p>
  `
})
export class DummyPageComponent {
}
